var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarAprovacao()}}},[_c('span',[_c('i',{staticClass:"fa fa-check-circle-o mr-2"}),_vm._v(" Aprovar ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }